import React from "react"

import "./style.scss"

export const PrivacyText = (props: React.HTMLProps<HTMLDivElement>) => {
    const { id, className } = props

    return (
        <div data-testid={id} id={id} className={`prv ${className ? className : ""}`}>
            By continuing, you agree to our{" "}
            <a target="_blank" href="https://blackpearlmail.com/about/privacy-policy/">
                Privacy&nbsp;Policy
            </a>
        </div>
    )
}
